var _defs, _g, _g2, _line, _g3, _g4, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnonymisierenImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "anonymize",
    viewBox: "0 0 768 480",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-1",
    x1: 261.86,
    x2: 261.86,
    y1: 0.4036,
    y2: 487.28,
    gradientTransform: "scale(1.4322 .69821)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F4FD",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 768,
    height: 480,
    display: "none",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180,379.4,225.74)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    transform: "rotate(180,375.05,182.68)",
    d: "m749.2 365.08c0-255.72-118.44-364.8-374.15-364.8-255.72 0-374.15 109.08-374.15 364.8z",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 568,
    cy: 54.282,
    r: 10.8,
    fill: "#e5eeff",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 689.2,
    cy: 175.48,
    r: 7.2,
    fill: "#f2f5fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    transform: "rotate(150,658,278.68)",
    d: "m649.35 281.55c-2.3172-8.8588 8.4627-16.207 15.213-8.9594 6.75 7.2481-1.4104 17.416-10.075 14.496-1.8134-0.60401-2.6194 2.3154-0.80597 2.9194 11.687 3.926 21.761-10.268 12.996-19.53-8.7649-9.3621-23.373 0.10067-20.25 11.879 0.50373 1.9127 3.4254 1.1073 2.9216-0.80534z",
    fill: "#c4d2ed"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.402,
    cy: 242.68,
    r: 7.2,
    fill: "#d7dbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 73.2,
    r: 6,
    fill: "#d7dbe7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.15 166.35c-2.3172-8.8588 8.4627-16.207 15.213-8.9594 6.75 7.2481-1.4104 17.416-10.075 14.496-1.8134-0.60401-2.6194 2.3154-0.80597 2.9194 11.687 3.926 21.761-10.268 12.996-19.53-8.7649-9.3621-23.373 0.10066-20.25 11.879 0.50373 1.9127 3.4254 1.1073 2.9216-0.80534z",
    fill: "#d9e4f7"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(163,146.8,319.48)",
    d: "m141.26 321.81c-1.9825-6.3548 6.1953-11.464 10.284-5.7318 3.7172 5.2334-2.4781 11.339-7.8061 8.5977-2.1064-1.1214-3.965 2.1183-1.8586 3.2397 9.0451 4.735 18.958-5.981 12.391-14.33-6.6909-8.5977-19.701-0.87223-16.603 9.2207 0.74344 2.2429 4.3367 1.3706 3.5933-0.99683z",
    fill: "#c7d5ee"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-15,617.2,144.28)",
    d: "m603.36 150.11c-4.9562-15.887 15.488-28.659 25.711-14.33 9.293 13.083-6.1953 28.348-19.515 21.494-5.266-2.8036-9.9125 5.2957-4.6465 8.0993 22.613 11.837 47.394-14.953 30.977-35.824-16.727-21.494-49.253-2.1806-41.509 23.052 1.8586 5.6072 10.842 3.4266 8.9832-2.4921z",
    fill: "#f3f6fe"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(30,43.602,115.48)",
    d: "m34.954 118.35c-2.3172-8.8588 8.4627-16.207 15.213-8.9594 6.75 7.2481-1.4104 17.416-10.075 14.496-1.8134-0.60401-2.6194 2.3154-0.80597 2.9194 11.687 3.926 21.761-10.268 12.996-19.53-8.7649-9.3621-23.373 0.10067-20.25 11.879 0.50373 1.9127 3.4254 1.1073 2.9216-0.80534z",
    fill: "#f4f7fe"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m431.52 127.68 29.022 211.67 2.6074 21.236c0.83999 6.8411-4.0249 13.068-10.866 13.908l-182.71 22.434c-6.8411 0.83999-13.068-4.0249-13.908-10.866l-28.129-229.09c-0.41999-3.4206 2.0124-6.534 5.433-6.954 0.0216-3e-3 0.0432-5e-3 0.0648-8e-3l15.158-1.7m12.257-1.3749 14.312-1.6054",
    fill: "#fff",
    stroke: "#5374a5",
    strokeLinecap: "round",
    strokeWidth: 7.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "m423.62 141 26.269 191.83 2.363 19.245c0.76124 6.1998-3.5881 11.836-9.7145 12.588l-163.62 20.09c-6.1264 0.75223-11.71-3.6639-12.471-9.8637l-25.428-207.09c-0.41999-3.4206 2.0124-6.534 5.433-6.954l20.241-2.4853",
    fill: "#e2ecff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m439.49 87.9c2.2746 0 4.4562 0.90323 6.0651 2.5111l41.943 41.917c1.6102 1.6092 2.5149 3.7924 2.5149 6.0688v195.2c0 2.3693-0.96035 4.5143-2.513 6.067-1.5527 1.5527-3.6977 2.513-6.067 2.513h-184.08c-2.3693 0-4.5143-0.96035-6.067-2.513-1.5527-1.5527-2.513-3.6977-2.513-6.067v-237.12c0-2.3693 0.96035-4.5143 2.513-6.067 1.5527-1.5527 3.6977-2.513 6.067-2.513z",
    fill: "#fff",
    stroke: "#5374a5",
    strokeWidth: 7.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 7.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440.88 91.497v36.183c0 5.1694 4.1906 9.36 9.36 9.36h24.753",
    stroke: "#5374a5"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line",
    x1: 322.32,
    x2: 403.44,
    y1: 137.04,
    y2: 137.04,
    stroke: "#79a3ff"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 322.32,
    x2: 456.48,
    y1: 174.48,
    y2: 174.48,
    stroke: "#5374a5"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 321.21,
    x2: 417.18,
    y1: 255.6,
    y2: 255.6,
    stroke: "#5374a5",
    strokeWidth: 6.5972
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 322.32,
    x2: 403.44,
    y1: 296.16,
    y2: 296.16,
    fill: "#79a3ff",
    fillRule: "evenodd",
    stroke: "#79a3ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7.8
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.73525 0 0 .69174 448.79 249.32)",
    fill: "#fff",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.576)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 58.406,
    cy: 58.406,
    r: 58.406
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(7.1885,7.1885)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.96,
    cy: 49.998,
    rx: 42.64,
    ry: 42.718
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 0,50.96 c 0,28.145 22.816,50.96 50.96,50.96 28.145,0 50.96,-22.816 50.96,-50.96 C 101.83772,22.85 79.07,0.082 50.96,0 22.815,0 0,22.816 0,50.96 Z",
    stroke: "#fff",
    strokeWidth: 2
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,2.0177)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7.8
  }, /*#__PURE__*/React.createElement("line", {
    x1: 429.49,
    x2: 456.48,
    y1: 213.02,
    y2: 213.02,
    fill: "none",
    stroke: "#5374a5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 321.19,
    x2: 355.57,
    y1: 213.02,
    y2: 213.02,
    fill: "none",
    stroke: "#5374a5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 415.51,
    x2: 369.55,
    y1: 213.02,
    y2: 213.02,
    fill: "#79a3ff",
    fillRule: "evenodd",
    stroke: "#79a3ff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m480.65 268.9 18.946 18.886v-0.95625a17.93 17.93 0 0 0-17.93-17.93h-1.016m-25.699 4.7812 9.2637 9.2636c-0.29883 1.2551-0.47813 2.5101-0.47813 3.8848a17.93 17.93 0 0 0 17.93 17.93c1.3148 0 2.6297-0.17929 3.8848-0.47811l9.2636 9.2636c-4.0043 1.9723-8.4269 3.1676-13.148 3.1676a29.883 29.883 0 0 1-29.883-29.883c0-4.7215 1.1953-9.1441 3.1676-13.148m-33.05-33.05 16.316 16.316c-9.8613 7.7695-17.631 17.93-22.293 29.883 10.339 26.237 35.859 44.824 65.742 44.824 9.2636 0 18.109-1.793 26.177-5.0203l2.5699 2.5102 17.452 17.452 7.5902-7.5902-105.96-105.96m52.175 23.906a29.883 29.883 0 0 1 29.883 29.883c0 3.825-0.77695 7.5304-2.1516 10.877l17.511 17.511c8.9648-7.4707 16.137-17.272 20.5-28.389-10.339-26.237-35.859-44.824-65.742-44.824-8.3672 0-16.376 1.4941-23.906 4.1836l12.969 12.85c3.4066-1.3148 7.0523-2.0918 10.937-2.0918z",
    fill: "#5374a5",
    strokeWidth: 5.9766
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnonymisierenImg);
export default __webpack_public_path__ + "static/media/Anonymisieren_img.a63c634186055437b4d5d8bfb9d1d900.svg";
export { ForwardRef as ReactComponent };